import { render, staticRenderFns } from "./additional-material.vue?vue&type=template&id=2f57ed09&scoped=true&"
import script from "./additional-material.vue?vue&type=script&lang=js&"
export * from "./additional-material.vue?vue&type=script&lang=js&"
import style0 from "./additional-material.vue?vue&type=style&index=0&id=2f57ed09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f57ed09",
  null
  
)

component.options.__file = "additional-material.vue"
export default component.exports